import { useQuery } from '@hooks/reactQuery';

import { getTimezones } from '@api/common';

import { fieldsOptionsFormatted } from '@utils/formatter';

import { refetchOptions } from '@constants/common';
import { TIMEZONES } from '@constants/queryKeys';

export const useQueryTimezones = () => {
	const {
		data: timezones,
		isLoading: isLoadingTimezones,
		isFetching: isFetchingTimezones,
	} = useQuery({
			queryKey: [TIMEZONES],
			queryFn: getTimezones,
			select: (timezones: Array<string>) => {
				if (!Array.isArray(timezones)) return [];

				return fieldsOptionsFormatted(timezones);
			},
			...refetchOptions,
		},
	);

	return {
		isLoadingTimezones: isLoadingTimezones || isFetchingTimezones,
		timezones: timezones || [],
	};
};
